import { HeaderTabs } from '.';
import { type BmwModuleSpecsFragment } from '../../../../api/fragments/BmwModuleSpecs';
import Authorization from './Authorization';
import BmwModuleForm from './BmwModuleForm';

type BmwModuleInnerPageProps = {
    activeTab: HeaderTabs;
    module: BmwModuleSpecsFragment;
};

const BmwModuleInnerPage = ({ activeTab, module }: BmwModuleInnerPageProps) => {
    switch (activeTab) {
        case HeaderTabs.Configuration:
            return <BmwModuleForm module={module} />;

        case HeaderTabs.Authorization:
            return <Authorization module={module} />;

        default:
            return null;
    }
};

export default BmwModuleInnerPage;
